import api from './api';
import { trackPromise } from 'react-promise-tracker';
import { getJwt } from '@app/helpers';
import Axios from 'axios';

export interface RelatorioPreContratacao {
  statusNome: string;
  respoPreContratacao: string;
  departamentoSigla: string;
  areaSigla: string;
  diretoriaSigla: string;
  demandanteNome: string;
  expectativa: number;
  tipoServicoNome: string;
  tipoTexto: string;
  demandaTexto: string;
  atividade1Inicio: any;
  dataAberturaRc: any;
}

export const getRelatorioPreContratacao = () => api.get<RelatorioPreContratacao[]>('relatorios/relatorioDemanda');
export const getRelatorioPreContratacaoExcel = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/relatorios/relatorioDemandaExcel`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorio_pre_contratacao.xlsx');
      link.setAttribute('id', 'downloadrelatorio_pre_contratacao');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadrelatorio_pre_contratacao').outerHTML = '';
    }),
  );
};
